import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { display_toggle_vertex_visibility } from '../../ui_display';
import { shift_pressed } from '@frontend/keypress';
import hide_vertices_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/hide_vertices.svg';
import { img } from '@phi/components';
import HideVerticesTooltip from './HideVerticesTooltip';

export const HideVerticesIcon = hide_vertices_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        disabled() {
            return this.coming_soon
                || this.state.editing_reference_sketches;
        },

        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show/hide vertices';
        },

        selected() {
            return this.state.tut_stage === 1;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                display_toggle_vertex_visibility(false, false, true, shift_pressed());
        },

        onLongClick() {
            if (this.disabled)
                return;
            else
                display_toggle_vertex_visibility(false, false, true, true);
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.selected,
            active: !this.state.currently_hiding_vertices,
            id: 'hide-vertices-button',
            tippy: 'top',
            long: true,
            onClick: this.onClick,
            onLongClick: this.onLongClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(hide_vertices_svg, this.alt),
            tooltip: HideVerticesTooltip,
        });
    }
});
